import { Skeleton } from '@mui/material';
import { ConditionnalPage, ConditionnalPageContainer } from './ConditionnalPageContainer';

export const PageLoading = ({ isPage = true }: ConditionnalPage) => (
  <ConditionnalPageContainer isPage={isPage}>
    <Skeleton sx={{ height: isPage ? '75vh' : 0, transform: 'none' }} />
  </ConditionnalPageContainer>
);
